// noinspection ES6CheckImport
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import ReactHtmlParser from 'react-html-parser'
import { ContentHeader, StaticBox, FlowTable, LinkedInput, LinkedInputGroup, Modal, NoContentBox } from 'components/basic'
import { notify, date, FormHelper } from 'helpers'
import { Installation } from 'config'
import http from 'API/http'

class Access extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      deactivationDate: null,
      activationDate: null,
      serviceToDisconnect: {},
      serviceToConnect: {},
      serviceToEdit: {},
      loadingLink: false,
      connectionModal: false,
      editModal: false,
      troubleModal: false,
      linkStatus: false,
      spReference: '',
      tickets: [],
      orders: false,
      activating: false,
      ticketModal: false
    }
    this.interval = null
  }
  componentDidMount () {
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
    this.getOrders(this.props.match.params.accessid)
    this.setState({linkStatus: null})
  }
  componentWillUnmount () {
    this.stopAutoReload()
  }
  async componentWillReceiveProps (nextProps) {
    if (this.props.match.params.accessid === nextProps.match.params.accessid) return false
    this.getAccess(nextProps.match.params.accessid)
    this.getTickets(nextProps.match.params.accessid)
    this.getOrders(nextProps.match.params.accessid)
    this.setState({linkStatus: null})
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  async getTickets (accessId) {
    if (!accessId) accessId = this.props.match.params.accessid
    var err, res
    [err, res] = await http.get('2.3/accesses/' + accessId + '/tickets')
    if (err) return notify.alert('', err.message, 'error')
    this.setState({tickets: res.data})
  }
  async getOrders (accessId) {
    if (!accessId) accessId = this.props.match.params.accessid
    var err, res
    [err, res] = await http.get('2.3/orderevents/access/' + accessId)
    if (!err) {
      this.setState({orders: res.data})
    }
  }
  autoReload () {
    this.stopAutoReload()
    this.interval = setTimeout(() => {
      this.getAccess()
    }, 30000)
  }
  stopAutoReload () {
    if (typeof this.interval !== 'undefined') {
      clearTimeout(this.interval)
      delete this.interval
    }
  }
  async getAccess (accessId) {
    if (!accessId) accessId = this.props.match.params.accessid
    var err, res
    [err, res] = await http.get('2.3/accesses/' + accessId)
    console.log(res);
    if (err) return notify.alert('', err.message, 'error')
    this.setState({access: res.data })
    this.autoReload()
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: `${res.data.streetName} ${res.data.streetNumber}`
    })
    console.log(this.state);
  }
  async getLinkStatus () {
    this.setState({loadingLink: true, troubleModal: true})
    var err, res
    [err, res] = await http.get('2.3/accesses/' + this.state.access.accessId + '/link/', {
      rich: true
    })
    if (err) {
      console.log(err, res)
      this.setState({loadingLink: false, troubleModal: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({loadingLink: false, linkStatus: res.data})
    console.log(res);
  }
  isDateValidActivate (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    if (this.state.serviceToConnect.available !== 'YES' && this.state.serviceToConnect.available !== 'NO') {
      return current.isSameOrAfter(moment(this.state.serviceToConnect.available))
    }
    return current.isAfter(yesterday)
  }
  static isDateValid (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }
  async deactivateService () {
    var err
    err = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToDisconnect.service,
      operation: 'DEACTIVATE',
      operationTime: (!this.state.deactivationDate ? null : this.state.deactivationDate.unix())
    })[0]
    if (err) return notify.alert('', err.message, 'error')
    this.setState({modalState: false})
    notify.alert('', 'The service will be deactivated ' + (!this.state.deactivationDate ? 'soon.' : moment(this.state.deactivationDate).format('YYYY-MM-DD')), 'success')
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
    this.getOrders(this.props.match.params.accessid)
  }
  async activateService () {
    var [err, res] = await http.get('2.3/orders/' + this.state.access.accessId + '/validate')
    var valid = await FormHelper.validate(this.form)
    if (!valid) return
    this.setState({activating: true})
    var err, res
    [err, res] = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToConnect.service,
      operationTime: (!this.state.activationDate ? null : this.state.activationDate.unix()),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: this.state.spReference,
      deliveryAddress: {
        smsNotificationPhone: '',
        streetName: this.state.access.streetName,
        streetNumber: this.state.access.streetNumber,
        streetLittera: this.state.access.streetLittera,
        zipCode: this.state.access.postalCode,
        city: this.state.access.city
      }
    })
    var activationDate = this.state.activationDate
    this.setState({
      activationDate: null,
      serviceToConnect: {},
      connectionModal: false,
      spReference: '',
      activating: false
    })
    if (err) return notify.alert('', err.response.data.cause, 'error')
    notify.alert('', 'The service will be activated ' + (!activationDate ? 'soon.' : moment(activationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
    this.getOrders(this.props.match.params.accessid)
  }
  getServiceAvailability (availability) {
    if (availability === 'YES') return <i className='fa fa-fw fa-check-circle text-success' />
    if (availability === 'NO') return <i className='fa fa-fw fa-times-circle text-danger' />
    return <span className='label label-primary'>{date.format(availability)}</span>
  }
  async openConnectionModal (service) {
    await http.get('2.3/accesses/' + this.state.access.accessId + '/availability')

    this.setState({serviceToConnect: service, connectionModal: true})
    if (service.available !== 'YES' && service.available !== 'NO') this.setState({activationDate: moment(service.available)})
  }
  editReference (service) {
    this.setState({serviceToEdit: service, editModal: true})
  }
  async saveServiceReference () {
    var err, res
    [err, res] = await http.post('2.3/accesses/' + this.state.access.accessId + '/service', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToEdit.service,
      spReference: this.state.serviceToEdit.spReference
    })
    if (err) return notify.warn('Could not update service')
    notify.success(this.state.serviceToEdit.service + ' has been updated.')
    this.setState({serviceToEdit: {}, editModal: false})
  }
  static arrayEqual (a, b) {
    let l = a.length
    if (l !== b.length) {
      return false
    }
    while (--l) {
      console.debug(l)
      if (a[l] !== b[l]) {
        return false
      }
    }
    return true
  }
  static isTable (a) {
    if (!Array.isArray(a)) {
      if (a.hasOwnProperty('styles') && a.hasOwnProperty('value')) {
        Access.isTable(a.value)
      }
      return false
    }
    if (a.length === 0) {
      return false
    }

    if (typeof a[0] !== 'object') {
      return false
    }
    let headers = Object.keys(a[0])
    let l = headers.length
    while (l--) {
      if (!['string', 'number'].includes(typeof headers[l]) ) {
        return false
      }
    }

    l = a.length
    while (l--) {
      if (!Access.arrayEqual(headers, Object.keys(a[l]))) {
        return false
      }
      let values = Object.values(a[l]).map(value => value.hasOwnProperty('value') ? value.value : value)
      let x = values.length

      while (x--) {
        if (!['string', 'number'].includes(typeof values[x])) {
          return false
        }
      }
    }
    return true
  }
  renderLinkStatus (children, count, level) {
    if (!children) return null
    if (!count) count = 0
    if (!level) level = 0
    let buffer = []

    level++
    var objectRows = []
    var objectData = []
    for (let key in children) {
      if (!children.hasOwnProperty(key)) {
        continue
      }
      let value = children[key]
      count++

      if (['string', 'boolean', 'number'].includes(typeof value) || value.hasOwnProperty('styles')) {
        objectRows.push(<th key={key + Math.random()}>{key}</th>)
        value.hasOwnProperty('value') ? value.hasOwnProperty('styles') ? objectData.push(<td style={value.styles} key={value.value + Math.random()}>{value.value}</td>) : objectData.push(<td key={value.value + Math.random()}>{value.value}</td>) : objectData.push(<td key={value + Math.random()}>{value}</td>)
        continue
      }

      if (Access.isTable(value)) {
        buffer.unshift(<div key={count}>
          <span className='child-level-text'>{key} <i className='fa fa-rotate-90 fa-mail-forward'/></span>
          <pre style={{overflow: 'hidden','padding': 0, 'paddingLeft': '10px'}}>
            <FlowTable data={value.map(row => Object.values(row).map(
              value => value.hasOwnProperty('value') ? value.hasOwnProperty('styles') ? {style: value.styles, content: value.value} : value.value : value
            ).reverse())}>
              <tr>
                {Object.keys(value[0]).map(key => <th key={count + '_' + key}>{key}</th>).reverse()}
              </tr>
            </FlowTable>
          </pre>
        </div>)
      } else {
        buffer.push(
          <div className={(level === 1 ? 'top-level-header' : 'margin-left-20')} key={count}>
            {(level === 1 ? <span className='top-level-text label label-primary'><i className='fa fa-fw fa-wrench' />{key}</span> : <span className='child-level-text'>{key} <i className='fa fa-rotate-90 fa-mail-forward'/></span>)}
            {this.renderLinkStatus(value, count, level)}
          </div>
        )
      }
    }

    if (objectRows.length != 0) {
      buffer.unshift(
        <div key={count + Math.random() + Date.now()}>
          <pre style={{overflow: 'hidden', 'padding': '0px'}}>
            <table className='table' id='sortable-table' >
              <thead><tr>{objectRows.map(row => row)}</tr></thead>
              <tbody>
                <tr>
                  {objectData.map(data => data)}
                </tr>
              </tbody>
            </table>
          </pre>
        </div>
      )
    }
    return buffer
  }

  render () {
    if (!this.state.access) return null
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle={`${this.state.access.streetName} ${this.state.access.streetNumber}`} buttons={[ { icon: 'fa-arrow-left', event: () => (window.location.hash = '/access') } ]} />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='home' title={`${this.state.access.streetName} ${this.state.access.streetNumber}`}>
            <div className='row'>
              <div className='col-md-4'>
                <label>Street</label>
                <LinkedInput context={this} editable={false} path='access.streetName' />
              </div>
              <div className='col-md-2'>
                <label>Number</label>
                <LinkedInput context={this} editable={false} path='access.streetNumber' />
              </div>
              <div className='col-md-2'>
                <label>Littera</label>
                <LinkedInput context={this} editable={false} path='access.streetLittera' />
              </div>
              <div className='col-md-2'>
                <label>Zipcode</label>
                <LinkedInput context={this} editable={false} path='access.postalCode' />
              </div>
              <div className='col-md-2'>
                <label>City</label>
                <LinkedInput context={this} editable={false} path='access.city' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-2'>
                <label>Apartment Number</label>
                <LinkedInput context={this} editable={false} path='access.mduApartmentNumber' />
              </div>
              <div className='col-md-2'>
                <label>Apartment Address</label>
                <LinkedInput context={this} editable={false} path='access.mduDistinguisher' />
              </div>
              <div className='col-md-2'>
                <label>Population</label>
                <LinkedInput context={this} editable={false} path='access.population' />
              </div>
              <div className='col-md-2'>
                <label>Premises Type</label>
                <LinkedInput context={this} editable={false} path='access.premisesType' />
              </div>
              <div className='col-md-2'>
                <label>Access ID</label>
                <LinkedInput context={this} editable={false} path='access.accessId' />
              </div>
            </div>
          </StaticBox>
        </div>
        <div className='row'>
          <StaticBox cols={12} icon='cog' title='Active Services'>
            <FlowTable data={this.state.access.active.map(service => [
              <a onClick={e => this.setState({serviceToDisconnect: service, modalState: true})} className='table-link'><i className='fa fa-remove' /></a>,
              service.service,
              <span>{service.spReference} <a className='table-link' onClick={e => this.editReference(service)}><i className='fa fa-pencil' /></a></span>,
              service.option82,
              (!service.activationDate ? '' : date.format(service.activationDate * 1000)),
              service.deactivationDate ? date.format(service.deactivationDate * 1000) : '',
              (Installation.enable.tickets && Installation.enable.ticketsCreate) ?
                <a onClick={e => (window.location = ('/#/ticket/wizard/' + this.state.access.accessId + '/' + window.btoa(service.service)))} className='table-link'><i className='fa fa-plus' /></a> :
                (!Installation.enable.ticketsCreate) ? <a onClick={e => this.setState({ticketModal: true})} className='table-link'><i className='fa fa-plus' /></a> : <i className='fa fa-ban text-muted' />])}>
              <tr>
                <th className='buttons' />
                <th>Service</th>
                <th>Your Internal Reference</th>
                <th>Option 82</th>
                <th>Activation Date</th>
                <th>Deactivation Date</th>
                <th className={(!Installation.enable.tickets ? 'text-muted' : '')}>Trouble Ticket</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <StaticBox cols={12} icon='cog' title='Available Services'>
                <FlowTable data={this.state.access.services.map(service => [
                  (service.available !== 'NO' && <a onClick={e => this.openConnectionModal(service)} className='table-link'><i className='fa fa-plus' /></a>),
                  this.getServiceAvailability(service.available),
                  service.service])}>
                  <tr>
                    <th className='buttons' />
                    <th className='buttons'>Available</th>
                    <th>Name</th>
                  </tr>
                </FlowTable>
              </StaticBox>
              {this.state.orders && <StaticBox cols={12} icon='cog' title='Orders'>
                <FlowTable paginatable={5} data={this.state.orders.map(order => [order.order.service, order.order.operation, date.format(order.timestamp), order.order.state])}>
                  <tr>
                    <th>Service</th>
                    <th>Operation</th>
                    <th>Time</th>
                    <th>State</th>
                  </tr>
                </FlowTable>
              </StaticBox>}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='row'>
              {Installation.enable.tickets && <StaticBox cols={12} icon='comments-o' title='Trouble Tickets' buttons={[
                {icon: 'fa-plus', event: e => (window.location = '/#/ticket/wizard/' + this.state.access.accessId), hidden: !Installation.enable.ticketsCreate},
                {icon: 'fa-plus', event: e => this.setState({ticketModal: true}), hidden: Installation.enable.ticketsCreate}
              ]}>
                <FlowTable paginatable={10} data={this.state.tickets.map(ticket => [<a href={'/#/ticket/' + ticket.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>, ReactHtmlParser(ticket.title), ticket.ticketRef, this.getStatus(ticket.state.status)])}>
                  <tr>
                    <th className='buttons' />
                    <th>Title</th>
                    <th>ID</th>
                    <th>Status</th>
                  </tr>
                </FlowTable>
              </StaticBox>}
            </div>
          </div>
          <div className='col-md-12' hidden={(!Installation.enable.troubleshooting)}>
            <div className='row'>
              <StaticBox icon='heartbeat' title='Troubleshooting' buttons={[
                {icon: 'fa-play', event: e => this.getLinkStatus('test')}
              ]}>
                <div className='col-md-12'>
                  {this.state.loadingLink &&
                  <h1 className='text-center'><i className='fa fa-fw fa-spin fa-cog' /></h1>
                  }
                  {this.state.linkStatus &&
                    this.renderLinkStatus(this.state.linkStatus)
                  }
                </div>
              </StaticBox>
            </div>
          </div>
        </div>
        <Modal noOverflow title={'Disconnect ' + this.state.serviceToDisconnect.service} isOpen={this.state.modalState} close={e => this.setState({modalState: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({modalState: false, serviceToDisconnect: {}}) },
            { text: 'Disconnect', event: e => this.deactivateService() }
        ]}>
          <label>Deactivation time</label>
          <Datetime isValidDate={this.isDateValid} value={this.state.deactivationDate} onChange={date => {
            this.setState({deactivationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
        </Modal>
        <Modal noOverflow title={'Connect ' + this.state.serviceToConnect.service} isOpen={this.state.connectionModal} close={e => this.setState({connectionModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({connectionModal: false, connect: {}}), hidden: this.state.activating },
            { text: 'Connect', event: e => this.activateService(), hidden: this.state.activating }
        ]}>
          <label>Activation time</label>
          <Datetime isValidDate={this.isDateValidActivate.bind(this)} value={this.state.activationDate} onChange={date => {
            this.setState({activationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />

          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spReference' />
              </div>
            </div>
          </LinkedInputGroup>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
        <Modal noOverflow title={'Edit ' + this.state.serviceToEdit.service} isOpen={this.state.editModal} close={e => this.setState({editModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({editModal: false, serviceToEdit: {}}) },
            { text: 'Save', event: e => this.saveServiceReference() }
        ]}>
          <LinkedInputGroup ref={(form) => { this.editForm = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='serviceToEdit.spReference' />
              </div>
            </div>
          </LinkedInputGroup>
        </Modal>
        <Modal title='Ticket Information' isOpen={this.state.ticketModal} close={e => this.setState({ticketModal: false})}>
          {ReactHtmlParser(Installation.ticketRules)}
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
Access = connect(state => state.siteReducer)(Access)
export default Access



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/access/access.js